import { identityProductLanguage } from "./identityDesignTokens";

function classes(base, variant, className) { return [base, variant && `${base}--${variant}`, className].filter(Boolean).join(" "); }

export function IdentityGrid({ variant = "restrained", className = "" }) {
  if (variant === "hidden") return null;
  return <span className={classes("identity-ds-grid", variant, className)} aria-hidden="true" />;
}

export function IdentitySpine({ variant = "compact", side = "left", className = "" }) {
  if (variant === "hidden") return null;
  return <span className={`${classes("identity-spine", variant, className)} identity-spine--${side}`} aria-hidden="true"><i /><i /><i /><i /><i /></span>;
}

export function IdentityPanel({ variant = "outline", className = "" }) {
  if (variant === "hidden") return null;
  return <span className={classes("identity-panel", variant, className)} aria-hidden="true" />;
}

export function IdentityLineGroup({ variant = "speed", className = "" }) {
  if (variant === "hidden") return null;
  return <span className={classes("identity-line-group", variant, className)} aria-hidden="true"><i /><i /><i /><i /></span>;
}

export function IdentityCorner({ variant = "bracket", position = "top-left", className = "" }) {
  if (variant === "hidden") return null;
  return <span className={`${classes("identity-corner", variant, className)} identity-corner--${position}`} aria-hidden="true" />;
}

export function IdentityQrFrame({ variant = "standard", className = "", children }) {
  if (variant === "none") return children;
  return <div className={classes("identity-qr-frame", variant, className)}><span className="identity-qr-frame-mark top" aria-hidden="true" /><span className="identity-qr-frame-mark top-right" aria-hidden="true" /><span className="identity-qr-frame-mark bottom-left" aria-hidden="true" /><span className="identity-qr-frame-mark bottom" aria-hidden="true" />{children}</div>;
}

export function IdentityEdge({ variant = "subtle", className = "" }) {
  if (variant === "none") return null;
  return <span className={classes("identity-edge", variant, className)} aria-hidden="true" />;
}

export function IdentityProductGraphics({ product, side = "left", className = "" }) {
  const language = identityProductLanguage[product];
  if (!language || product === "qr") return null;
  return <div className={`identity-product-graphics identity-product-graphics--${product} ${className}`} aria-hidden="true">
    <IdentityGrid variant={language.grid} />
    <IdentityPanel variant={language.panel} />
    <IdentitySpine variant={language.spine} side={side} />
    <IdentityLineGroup variant={language.lines} />
    <IdentityCorner variant={language.corners} position="top-right" />
    <IdentityCorner variant={language.corners} position="bottom-left" />
    <IdentityEdge variant={language.edge} />
  </div>;
}
